import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bodyAreas, showcaseFeatures } from '../data/content';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-190" data-mp="32luq9svms8pb">
      <div className="mx-auto max-w-4xl text-center" data-id="element-191" data-mp="32kjq031e9j2y">
        <Eyebrow data-id="element-192" data-mp="2xlyn1vurclat">The complete 5-volume injury rehabilitation system</Eyebrow>
        <h2 className="font-display text-xl font-black uppercase leading-tight text-navy md:text-3xl" data-id="element-193" data-mp="29we0l2zeb5ws">
          Complete Injury Rehabilitation Bundle
        </h2>
        <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-wide text-steel md:text-sm" data-id="element-194" data-mp="24zdtqpuq1z4m">
          Practical exercises ready for coaches, trainers & active adults
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-2 gap-y-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-195" data-mp="2eufktr8k5b9u">
          {bodyAreas.map((area, index) => <li key={area} className="flex items-center gap-2" data-id="element-196" data-mp="3qa468e65y28j" data-mpi={index}>
              {index > 0 && <span className="text-navy/30" aria-hidden="true" data-id="element-197" data-mp="249dzzkhpbsuh">
                  •
                </span>}
              {area}
            </li>)}
        </ul>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-198" data-mp="2e83gp9xv3795">
          {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-navy/10 bg-white px-4 py-2.5 text-sm font-semibold text-navy" data-id="element-199" data-mp="2i8nhqolk2v0k">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-200" data-mp="1qju1wrz2fjri">
                <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-201" data-mp="1ujkqcp14dnsv" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}